import MenuItem from "@mui/material/MenuItem"
import FormControl from "@mui/material/FormControl"
import FormLabel from "@mui/material/FormLabel"
import Select from "@mui/material/Select"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import Loader from "../Loader"


export default function SelectInput(props: any) {
    const { name, value, onChange, options, error, helperText, placeholder, style } = props

    return props.isLoading !== undefined ? (
        !props.isLoading ? (
            <FormControl variant="standard" sx={{ width: "100%", margin: "12.5px 0px" }}>
                <FormLabel
                    disabled={props?.disabled}
                    id={name}
                    sx={{ fontWeight: props?.labelFontWeight, width: "100%" }}
                >
                    {props?.label && <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                        <Typography>
                            {props?.label}
                        </Typography>
                        {props?.required && <Typography sx={{ color: "#E20000", fontSize: "14px", fontWeight: 500 }}>*</Typography>}
                    </Box>}
                    {props?.subLabel && (
                        <FormLabel
                            disabled={props?.disabled}
                            id={name}
                            sx={{ fontWeight: props?.subLabelFontWeight }}
                            required={props.required}
                        >
                            {props.subLabel}
                        </FormLabel>
                    )}

                    <Select
                        {...props}
                        required={props?.required}
                        id={name}
                        value={value}
                        label={undefined}
                        onChange={onChange}
                        displayEmpty
                        fullWidth
                        placeholder={placeholder}
                        inputProps={{ "aria-label": "Without label" }}
                        sx={
                            props?.disabled
                                ? {
                                    ...style,
                                    fontFamily: "Poppins",
                                    "& .MuiSelect-select": {
                                        padding: "0px",
                                    },
                                    "& .MuiSelect-icon": {
                                        top: "13px",
                                        right: "10px",
                                        height: "10px",
                                        width: "10px",
                                    },
                                    padding: "10px",
                                    fontSize: "12px",
                                    cursor: "not-allowed",
                                    "&:hover::before ": {
                                        borderBottomColor: "#007AFF !important"
                                    },
                                    "&::after": {
                                        borderBottomColor: "#007AFF !important"
                                    }
                                }
                                : {
                                    ...style,
                                    fontFamily: "Poppins",
                                    "& .MuiSelect-select": {
                                        padding: "0px",
                                    },
                                    "& .MuiSelect-icon": {
                                        top: "13px",
                                        right: "10px",
                                        height: "10px",
                                        width: "10px",
                                    },
                                    padding: "10px",
                                    fontSize: "12px",
                                    "&:hover::before ": {
                                        borderBottomColor: "#007AFF !important"
                                    },
                                    "&::after": {
                                        borderBottomColor: "#007AFF !important"
                                    }
                                }
                        }
                        renderValue={(selected: any) => {
                            const getSelected = options?.filter((options: any) => {
                                return options?.label == selected ? options.label : ""
                            })

                            if (!selected) {
                                return (
                                    <div
                                        style={{
                                            color: "#B7BAC6",
                                        }}
                                    >
                                        {placeholder}
                                    </div>
                                )
                            }
                            if (getSelected?.length > 0) {
                                return getSelected.map((options: any) => (
                                    <span
                                        key={options.label}
                                        style={
                                            props?.disabled
                                                ? {
                                                    cursor: "not-allowed",
                                                    fontFamily: "Poppins !important",
                                                    fontSize: "12px",
                                                }
                                                : { fontFamily: "Poppins !important", fontSize: "12px" }
                                        }
                                    >
                                        {options.label}
                                    </span>
                                ))
                            }
                        }}
                    >
                        {options?.map((option: any) => (
                            <MenuItem
                                sx={{ fontSize: "12px", fontFamily: "Poppins !important" }}
                                key={option?.id}
                                value={option?.id}
                            >
                                {option?.label}
                            </MenuItem>
                        ))}
                    </Select>
                    {error && (
                        <Typography className="error_message" style={{ marginTop: 3 }}>
                            {helperText}
                        </Typography>
                    )}

                </FormLabel>
            </FormControl>
        ) : (
            <Loader />
        )
    ) : (
        <FormControl variant="standard" sx={{ width: "100%", margin: "12.5px 0px" }}>
            <FormLabel
                disabled={props?.disabled}
                id={name}
                sx={{ fontWeight: props?.labelFontWeight, width: "100%" }}
            >
                {props?.label && <Box sx={{ display: "flex", alignItems: "center", gap: "4px" }}>
                    <Typography>
                        {props?.label}
                    </Typography>
                    {props?.required && <Typography sx={{ color: "#E20000", fontSize: "14px", fontWeight: 500 }}>*</Typography>}
                </Box>}
                {props?.subLabel && (
                    <FormLabel
                        disabled={props?.disabled}
                        id={name}
                        sx={{ fontWeight: props?.subLabelFontWeight }}
                        required={props.required}
                    >
                        {props.subLabel}
                    </FormLabel>
                )}
                <Select
                    {...props}
                    required={props?.required}
                    id={name}
                    value={value}
                    label={undefined}
                    onChange={onChange}
                    displayEmpty
                    fullWidth
                    placeholder={placeholder}
                    inputProps={{ "aria-label": "Without label" }}
                    sx={
                        props?.disabled
                            ? {
                                ...style,
                                fontFamily: "Poppins",
                                "& .MuiSelect-select": {
                                    padding: "0px",
                                },
                                "& .MuiSelect-icon": {
                                    top: "13px",
                                    right: "10px",
                                    height: "10px",
                                    width: "10px",
                                },
                                padding: "10px",
                                fontSize: "12px",
                                cursor: "not-allowed",
                            }
                            : {
                                ...style,
                                fontFamily: "Poppins",
                                "& .MuiSelect-select": {
                                    padding: "0px",
                                },
                                "& .MuiSelect-icon": {
                                    top: "13px",
                                    right: "10px",
                                    height: "10px",
                                    width: "10px",
                                },
                                padding: "10px",
                                fontSize: "12px",
                                "&:hover::before ": {
                                        borderBottomColor: "#007AFF !important"
                                    },
                                    "&::after": {
                                        borderBottomColor: "#007AFF !important"
                                    }
                            }
                    }
                    renderValue={(selected: any) => {
                        const getSelected = options?.filter((options: any) => {
                            return options?.id == selected ? options.label : ""
                        })

                        if (!selected) {
                            return (
                                <div
                                    style={{
                                        color: "#B7BAC6",
                                    }}
                                >
                                    {placeholder}
                                </div>
                            )
                        }
                        if (getSelected?.length > 0) {
                            return getSelected.map((options: any) => (
                                <span
                                    key={options.label}
                                    style={
                                        props?.disabled
                                            ? { cursor: "not-allowed", fontFamily: "Poppins !important", fontSize: "12px" }
                                            : { fontFamily: "Poppins !important", fontSize: "12px" }
                                    }
                                >
                                    {options.label}
                                </span>
                            ))
                        }
                    }}
                >
                    {options?.map((option: any) => (
                        <MenuItem
                            sx={{ fontSize: "12px", fontFamily: "Poppins !important" }}
                            key={option?.id}
                            value={option?.id}
                        >
                            {option?.label}
                        </MenuItem>
                    ))}
                </Select>
            </FormLabel>
            {error && (
                <Typography className="error_message" sx={{ marginTop: "3px", fontSize: "12px" }}>
                    {helperText}
                </Typography>
            )}
        </FormControl>
    )
}
